import { render, staticRenderFns } from "./NewsBarPreview.vue?vue&type=template&id=75837fba&scoped=true&"
import script from "./NewsBarPreview.vue?vue&type=script&lang=js&"
export * from "./NewsBarPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewsBarPreview.vue?vue&type=style&index=0&id=75837fba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75837fba",
  null
  
)

export default component.exports